import type { BillingPaymentRow } from '../types/billing.types';
import { formatBRL } from '../utils/cashFlow.utils';
import { BillingStatusBadge } from './BillingStatusBadge';
import styles from './BillingTable.module.css';

interface BillingTableProps {
	rows: BillingPaymentRow[] | undefined;
}

const COLUMNS = ['Plano', 'ID', 'Cliente', 'Cidade', 'Gateway', 'Método', 'Data', 'Horário', 'Preço', 'Status'];

export const BillingTable = ({ rows }: BillingTableProps) => (
	<div className={styles.tableWrapper}>
		<table className={styles.table}>
			<thead className={styles.thead}>
				<tr>
					{COLUMNS.map((column) => (
						<th key={column}>{column}</th>
					))}
				</tr>
			</thead>

			<tbody className={styles.tbody}>
				{rows?.map((row) => (
					<tr key={row._id}>
						<td className={styles.colPlan}>{row.planName}</td>
						<td title={row.chargeId}>{row.shortChargeId}</td>
						<td>{row.clientName}</td>
						<td>{row.city}</td>
						<td>{row.gateway}</td>
						<td>{row.method}</td>
						<td>{row.date}</td>
						<td>{row.time}</td>
						<td>{formatBRL(row.amount)}</td>
						<td>
							<BillingStatusBadge status={row.chargeStatus} />
						</td>
					</tr>
				))}
			</tbody>
		</table>
	</div>
);
